import React from 'react'
import "./style.scss"
import { useGetProductDetailsQuery } from "../../../../services/homeAPI"
import { useGetColorThemeQuery } from "../../../../services/commonAPI";
import Loader from "../../fullPageLoader"

function Index() {

    const { data, error, isLoading } = useGetProductDetailsQuery();

    const {
        data: colorthemeData,
    } = useGetColorThemeQuery();

    if (isLoading) return <Loader />;
    if (error) return <p>Failed to load data</p>;

    return (
        <section className='product-details' style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.banner_bg_color || "#F1EEEE" }}>
            <div className='container'>
                <div className='row align-items-center' data-aos="fade-up">
                    <div className='col-md-6 col-lg-6 col-sm-12 text-start'>
                        <h5 style={{ color: colorthemeData?.color_themes?.[0]?.text_color_one }}>{data?.data[0]?.sub_heading}</h5>
                        <h4 style={{ color: colorthemeData?.color_themes?.[0]?.heading_color || "#000" }}>{data?.data[0]?.main_heading}</h4>
                        <p className='sub-text' style={{ color: colorthemeData?.color_themes?.[0]?.paragraph_color || "##767676" }}>{data?.data[0]?.description}</p>

                        <div className='row' data-aos="fade-up">
                            <div className='col-md-6 col-lg-6 col-sm-12 text-start'>
                                <div className='d-flex mtb-20'>

                                    <div>
                                        {data?.data[0]?.logo_one && data?.data[0]?.log_heading_one && <img src={data?.data[0]?.logo_one} alt='img' className='branding-section-logo' loading="lazy" />}

                                    </div>
                                    <div
                                        className='product-detail-content'>
                                       {data?.data[0]?.log_heading_one && <p className='head-text' style={{ color: colorthemeData?.color_themes?.[0]?.heading_color || "#000" }} >{data?.data[0]?.log_heading_one}</p>}
                                       {data?.data[0]?.content_one &&   <p className='detail-text' style={{ color: colorthemeData?.color_themes?.[0]?.text_color_one }}>{data?.data[0]?.content_one}</p>}
                                    </div>
                                </div>
                            </div>

                            <div className='col-md-6 col-lg-6 col-sm-12 text-start'>
                                <div className='d-flex mtb-20'>

                                    <div>
                                        {data?.data[0]?.logo_two && data?.data[0]?.log_heading_two &&<img src={data?.data[0]?.logo_two} alt='img' className='branding-section-logo' loading="lazy" />}

                                    </div>
                                    <div
                                        className='product-detail-content'>
                                        
                                        {data?.data[0]?.log_heading_two && <p className='head-text' style={{ color: colorthemeData?.color_themes?.[0]?.heading_color || "#000" }} >{data?.data[0]?.log_heading_two}</p>}
                                       {data?.data[0]?.content_two && <p className='detail-text' style={{ color: colorthemeData?.color_themes?.[0]?.text_color_one }}>{data?.data[0]?.content_two}</p>}
                                    </div>
                                </div>
                            </div>

                            <div className='col-md-6 col-lg-6 col-sm-12 text-start'>
                                <div className='d-flex mtb-20'>

                                    <div>
                                        {data?.data[0]?.log_heading_three && <img src={data?.data[0]?.logo_three} alt='img' className='branding-section-logo' loading="lazy"/>}

                                    </div>
                                    <div
                                        className='product-detail-content'>
                                      {data?.data[0]?.log_heading_three &&  <p className='head-text' style={{ color: colorthemeData?.color_themes?.[0]?.heading_color || "#000" }}>{data?.data[0]?.log_heading_three}</p>}
                                      {data?.data[0]?.content_three && <p className='detail-text' style={{ color: colorthemeData?.color_themes?.[0]?.text_color_one }}>{data?.data[0]?.content_three}</p>}
                                    </div>
                                </div>
                            </div>

                            <div className='col-md-6 col-lg-6 col-sm-12 text-start'>
                                <div className='d-flex mtb-20'>

                                    <div>
                                        {data?.data[0]?.logo_four && data?.data[0]?.log_heading_four && <img src={data?.data[0]?.logo_four} alt='img' className='branding-section-logo' loading="lazy"/>}

                                    </div>
                                    <div
                                        className='product-detail-content'>
                                       {data?.data[0]?.log_heading_four &&  <p className='head-text' style={{ color: colorthemeData?.color_themes?.[0]?.heading_color || "#000" }}>{data?.data[0]?.log_heading_four}</p>}
                                       {data?.data[0]?.content_four && <p className='detail-text' style={{ color: colorthemeData?.color_themes?.[0]?.text_color_one }}>{data?.data[0]?.content_four}</p>}
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                    <div className='col-md-6 col-lg-6 col-sm-12'>
                        <img src={data?.data[0]?.main_image} className='right-img' alt="img" loading="lazy"/>
                    </div>
                </div>

            </div>
        </section>
    )
}

export default Index